<template>
  <div class="image-cropper-container">
    <input ref="imageFile" type="file" name="image" accept="image/*" @change="setImage" style="display: none" />
    <div class="image-cropper" :style="cropperStyles" @click="cropperAreaClicked" :class="[circleCrop ? 'image-cropper-circle-cropper' : '']">
      <vue-cropper
        ref="cropper"
        :guides="true"
        :view-mode="0"
        drag-mode="crop"
        :auto-crop-area="0.5"
        :min-container-width="minContainerWidth"
        :min-container-height="minContainerHeight"
        :background="false"
        :rotatable="false"
        :aspectRatio="aspectRatio"
        :src="imgSrc"
        v-show="imgSrc"
        alt=" "
        :img-style="{ 'width': width, 'height': height, 'color': 'transparent' }"
        @ready="cropperReady"
        @cropstart="$emit('cropStarted', $event.detail)"
        @crop="$emit('cropUpdated', $event.detail)">
      </vue-cropper>
    </div>
    <div class="mt-1">
      <a class="btn btn-white" @click.prevent="$refs.imageFile.click()"><i class="far fa-upload"> </i> Import Image</a>&nbsp;
      <a class="btn btn-white" v-show="false" @click.prevent="cropperReset()"><i class="far fa-sync"> </i> Reset</a>&nbsp;
      <a class="btn btn-white" v-show="false" @click.prevent="cropperZoomIn()"><i class="far fa-search-plus"> </i> </a>
      <a class="btn btn-white" v-show="false" @click.prevent="cropperZoomOut()"><i class="far fa-search-minus"> </i> </a>&nbsp;
    </div>
  </div>
</template>

<style scoped>
.image-cropper {
  border: 1px solid #efefef;
  display: inline-block;
}

.image-cropper-circle-cropper .cropper-view-box, .image-cropper-circle-cropper .cropper-face {
  border-radius: 50%;
}
</style>

<script>
import _ from 'lodash'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

import formField from '@/mixins/formField'

export default {
  name: 'FormImageCropper',
  mixins: [formField],
  components: {
    VueCropper
  },
  props: {
    width: {
      type: [Number, String],
      default: '100%'
    },
    height: {
      type: [Number, String],
      default: '200px'
    },
    minContainerWidth: {
      type: [Number, String],
      default: 250
    },
    minContainerHeight: {
      type: [Number, String],
      default: 180
    },
    aspectRatio: {
      type: Number,
      default: null
    },
    circleCrop: {
      type: Boolean,
      default: false
    }    
  },
  data() {
    return {
      imgSrc: '',
      image: {},
    }
  },
  computed: {
    cropperStyles() {
      return {
        width: this.width,
        height: this.height
      }
    }
  },
  methods: {
    cropperReady(e) {
      let canvasData = this.$refs.cropper.getCanvasData()

      // Set crop to full image
      if(this.imgSrc && canvasData.width && canvasData.height) {
        this.$refs.cropper.setCropBoxData({
          left: canvasData.left,
          top: canvasData.top,
          width: canvasData.width,
          height: canvasData.height
        })
      }
    },
    cropperAreaClicked() {
      if(!this.imgSrc) {
        this.$refs.imageFile.click()
      }
    },
    cropperReset() {
    },
    cropperZoomIn() {
    },
    cropperZoomOut() {
    },
    setImage(e) {
      const file = e.target.files[0];
      if(file == null)
        return

      if (!file.type.includes('image/')) {
        this.errorMessage('Error', 'Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)

          this.$emit('imageUpdated')
        };
        reader.readAsDataURL(file)
      } else {
        this.errorMessage('Error', 'Sorry, FileReader API not supported. Please update your browser or use Chrome/Firefox/Safari');
      }
    },
    getCroppedCanvasPNGUrl(options) {
      let cropOptions = _.defaults(options, {
        minWidth: 16,
        minHeight: 16,
        maxWidth: 512,
        maxHeight: 512,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      })

      var croppedCanvas = this.$refs.cropper.getCroppedCanvas(cropOptions)
      return croppedCanvas.toDataURL('image/png')
    },
    setImageFromDataURL(data) {
      this.imgSrc = data
      this.$refs.cropper.replace(data, false)
    }
  }
}
</script>